export default "__VITE_ASSET__DAb1AMdw__"